/**
 * Converts a camelCase string to snake_case
 */
function camelToSnake(str: string): string {
  return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
}

/**
 * Converts an object with camelCase keys to snake_case keys
 */
export function toSnakeCase<T extends Record<string, any>>(obj: T): Record<string, any> {
  const result: Record<string, any> = {};

  for (const [key, value] of Object.entries(obj)) {
    let snakeKey = camelToSnake(key);
    // Global query params compatibility:
    // Frontend historically used `sort`/`order`, while backend expects `sort_by`/`sort_order`.
    if (snakeKey === 'sort') snakeKey = 'sort_by';
    if (snakeKey === 'order') snakeKey = 'sort_order';

    // Handle arrays - recursively transform objects inside arrays
    if (Array.isArray(value)) {
      result[snakeKey] = value.map((item) => {
        if (
          item !== null &&
          typeof item === 'object' &&
          !(item instanceof File) &&
          !(item instanceof Date)
        ) {
          return toSnakeCase(item);
        }
        return item;
      });
    }
    // Handle nested objects (like location)
    else if (
      value !== null &&
      typeof value === 'object' &&
      !(value instanceof File) &&
      !(value instanceof Date)
    ) {
      result[snakeKey] = toSnakeCase(value);
    } else if (value instanceof Date) {
      result[snakeKey] = value.toISOString();
    } else {
      result[snakeKey] = value;
    }
  }

  return result;
}
